import {queryOptions} from '@tanstack/react-query';
import {api} from '@/libs/baseApi.client';
import type {CurrentCompetitionResponse} from '../types/TCompetition';
import {leaderBoardsKeys} from './leaderBoardsKeys';

// Интервал автообновления текущего соревнования (30 секунд)
const COMPETITION_REFETCH_INTERVAL = 30 * 1000;

export const getCurrentCompetitonOptions = () =>
  queryOptions({
    queryKey: leaderBoardsKeys.current(),
    queryFn: async () => {
      try {
        const response = await api.get<CurrentCompetitionResponse>(`/competitions/current`);
        return response.data;
      } catch (error) {
        console.error('Failed to fetch current competition:', error);
        return null;
      }
    },
    staleTime: 10 * 1000, // 10 секунд - данные считаются свежими
    gcTime: 3 * 60 * 1000, // 3 минуты в кэше
    refetchOnMount: true,
    refetchInterval: COMPETITION_REFETCH_INTERVAL, // Автообновление каждые 30 сек
    refetchIntervalInBackground: false, // Не обновлять когда вкладка неактивна
    retry: 1,
  });
